import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {NotificationService} from '../../utils/notification.service';

declare var $: any;

@Component({
  selector: 'sa-logout',
  template: `
    <div id="logout" (click)="showPopup()" class="btn btn-default transparent pull-right" style="margin-top:1px;s">
        <span> <a routerlink="/auth/login" title="Sign Out" data-action="userLogout"
                  style="margin-top:0px;padding:0px;"
                  data-logout-msg="Are you sure you want to logout?"><i
            class="fa fa-lg fa-sign-out"></i></a> </span>
    </div>
  `,
  styles: []
})
export class LogoutComponent implements OnInit {

  constructor(private router: Router,
              private notificationService: NotificationService) {
  }

  showPopup() {
    this.notificationService.smartMessageBox({
      title: '<i class=\'fa fa-sign-out txt-color-orangeDark\'></i> Logout <span class=\'txt-color-orangeDark\'><strong>' + $('#show-shortcut').text() + '</strong></span> ?',
      content: 'Are you sure you want to logout?',
      buttons: '[No][Yes]'

    }, (ButtonPressed) => {
      if (ButtonPressed === 'Yes') {
        this.logout()
      }
    });
  }

  logout() {
    console.log('logout');
    this.router.navigate(['/auth/login'])
  }

  ngOnInit() {

  }


}



// WEBPACK FOOTER //
// ./src/app/shared/user/logout/logout.component.ts